export default "__VITE_ASSET__$Uh6sOGM__"